import { z } from 'zod';
/**
 * Lista de supresión: las direcciones a las que NO se les manda marketing.
 *
 * Es la primera pieza del módulo de Marketing y va antes que las campañas a
 * propósito. El derecho de oposición al marketing directo (art. 21.2 RGPD) es
 * absoluto —no hay que motivarlo ni se puede ponderar— y el art. 21 LSSI-CE
 * obliga a que darse de baja sea tan fácil como recibir. Construir primero el
 * motor de envío y la lista después es cómo se acaba mandando a quien ya dijo
 * que no.
 */
export const MARKETING_SUPPRESSION_REASONS = [
    /** La persona se dio de baja (enlace, respuesta, se lo dijo a alguien). */
    'BAJA',
    /** El servidor devolvió el correo de forma permanente: la dirección no vale. */
    'REBOTE',
    /** Lo marcó como spam. Pesa más que una baja: seguir escribiendo quema el dominio. */
    'QUEJA',
    /** Lo metimos a mano por cualquier otro motivo; se explica en las notas. */
    'MANUAL',
];
export const MarketingSuppressionDtoSchema = z.object({
    id: z.string(),
    email: z.string(),
    reason: z.enum(MARKETING_SUPPRESSION_REASONS),
    source: z.string().nullable(),
    notes: z.string().nullable(),
    createdAt: z.string(),
    createdByName: z.string().nullable(),
    /** Si esa dirección es de algún cliente de la agenda, para poder ir a su ficha. */
    clientId: z.string().nullable(),
    clientName: z.string().nullable(),
});
export const MarketingSuppressionListResponseSchema = z.object({
    items: z.array(MarketingSuppressionDtoSchema),
    total: z.number().int(),
});
export const CreateMarketingSuppressionSchema = z.object({
    /**
     * Se admiten varias de golpe separadas por comas o saltos de línea: lo normal
     * es pegar aquí lo que ha devuelto el correo o una lista que alguien pasa.
     */
    emails: z.string().trim().min(3).max(20000),
    reason: z.enum(MARKETING_SUPPRESSION_REASONS).default('MANUAL'),
    source: z.string().trim().max(200).nullable().optional(),
    notes: z.string().trim().max(500).nullable().optional(),
});
export const CreateMarketingSuppressionResponseSchema = z.object({
    creados: z.number().int(),
    /** Ya estaban: no es un error, se dice y ya. */
    yaEstaban: z.number().int(),
    /** Lo que no parecía una dirección de correo, tal cual se escribió. */
    invalidos: z.array(z.string()),
});
/**
 * ☠️ Sacar a alguien de la lista EXIGE un motivo escrito. Quitar una baja es
 * volver a escribir a quien pidió no recibir nada: si algún día hay que
 * responder por ello, esto es lo único que queda. Va al registro de auditoría.
 */
export const RemoveMarketingSuppressionSchema = z.object({
    reason: z
        .string()
        .trim()
        .min(10, 'Explica por qué se saca de la lista: lo pide quien pregunte mañana')
        .max(500),
});
/** Comprobación previa del compositor de correo: ¿alguno de estos está de baja? */
export const CheckMarketingSuppressionSchema = z.object({
    emails: z.array(z.string()).min(1).max(500),
});
export const CheckMarketingSuppressionResponseSchema = z.object({
    suprimidos: z.array(z.object({
        email: z.string(),
        reason: z.enum(MARKETING_SUPPRESSION_REASONS),
        createdAt: z.string(),
    })),
});
//# sourceMappingURL=marketing-suppression.js.map